import React, { useState } from 'react';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { useToolContext } from 'contexts/ToolContext';

function ToolSelector() {
    const { lstTool, selectedTool, selectedToolName, setSelectedTool, isLoading } = useToolContext();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);

    if (isLoading || lstTool.length === 0) {
        return null;
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle} className="tool-selector">
            <DropdownToggle
                caret
                style={{
                    backgroundColor: '#51cbce',
                    borderColor: '#51cbce',
                    color: '#fff',
                    fontWeight: '600',
                    fontSize: '14px'
                }}
            >
                {selectedToolName || 'Chọn phần mềm'}
            </DropdownToggle>
            <DropdownMenu>
                {lstTool.map((tool, key) => {
                    const isActive = selectedTool === tool.matool;
                    return (
                        <DropdownItem
                            key={key}
                            active={isActive}
                            onClick={() => setSelectedTool(tool.matool, tool.name, true)}
                            style={isActive ? {
                                backgroundColor: '#51bcda',
                                color: '#fff',
                                fontWeight: 'bold'
                            } : {}}
                        >
                            {tool.name}
                        </DropdownItem>
                    );
                })}
            </DropdownMenu>
        </Dropdown>
    );
}

export default ToolSelector;
